var map = {
	"./afb-color.svg": 1748,
	"./afb.svg": 1749,
	"./alb-color.svg": 1750,
	"./alb.svg": 1751,
	"./amb-color.svg": 1752,
	"./amb.svg": 1753,
	"./bbbaidja-color.svg": 1754,
	"./bbbaidjaxxx-color.svg": 1755,
	"./bdinidjaxxx-color.svg": 1756,
	"./bimb-color.svg": 1757,
	"./bimb.svg": 1758,
	"./bkr-color.svg": 1759,
	"./bkr.svg": 1760,
	"./bmriidja-color.svg": 1761,
	"./bniaidja-color.svg": 1762,
	"./bninidja-color.svg": 1763,
	"./bninidjaxxx-color.svg": 1764,
	"./bpay-color.svg": 1765,
	"./brinidja002-color.svg": 1766,
	"./bsmdidjaxxx-color.svg": 1767,
	"./bsn-color.svg": 1768,
	"./bsn.svg": 1769,
	"./btanidjaxxx-color.svg": 1770,
	"./cenaidja-color.svg": 1771,
	"./cenaidjaxxx-color.svg": 1772,
	"./cimb-color.svg": 1773,
	"./cimb.svg": 1774,
	"./citi-color.svg": 1775,
	"./citi.svg": 1776,
	"./default-bank-icon-color.png": 1777,
	"./default-bank-icon.png": 1778,
	"./gxbank-color.svg": 1779,
	"./hlb-color.svg": 1780,
	"./hlb.svg": 1781,
	"./hsbc-color.svg": 1782,
	"./hsbc.svg": 1783,
	"./ibbkidjaxxx-color.svg": 1784,
	"./kwh-color.svg": 1785,
	"./kwh.svg": 1786,
	"./mbb-color.svg": 1787,
	"./mbb.svg": 1788,
	"./nispidjaxxx-color.svg": 1789,
	"./ocbc-color.svg": 1790,
	"./ocbc.svg": 1791,
	"./pbb-color.svg": 1792,
	"./pbb.svg": 1793,
	"./pinbidja-color.svg": 1794,
	"./rhb-b.svg": 1795,
	"./rhb-color-b.svg": 1796,
	"./rhb-color.svg": 1797,
	"./rhb.svg": 1798,
	"./scb-color.svg": 1799,
	"./scb.svg": 1800,
	"./tng-color.svg": 1801,
	"./uob-color.svg": 1802,
	"./uob.svg": 1803
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 128;